import { mapState } from 'vuex'
import createApp from 'createApp'
const companyProfileBar = () => import('Components/CompanyProfile/companyProfileBar.vue')
const companyProfileContact = () => import('Components/CompanyProfile/companyProfileContact.vue')
const companyProfileFaq = () => import('Components/CompanyProfile/companyProfileFaq.vue')
const companyProfileGallery = () => import('Components/CompanyProfile/companyProfileGallery.vue')
const companyProfileHeader = () => import('Components/CompanyProfile/companyProfileHeader.vue')
const companyProfileInfo = () => import('Components/CompanyProfile/companyProfileInfo.vue')
const companyProfileLocation = () => import('Components/CompanyProfile/companyProfileLocation.vue')
const companyProfileRating = () => import('Components/CompanyProfile/companyProfileRating.vue')
const companyProfileReview = () => import('Components/CompanyProfile/companyProfileReview.vue')
const companyProfileSkill = () => import('Components/CompanyProfile/companyProfileSkill.vue')
const collapseContent = () => import('Components/collapseContent.vue')

const initialState = () => ({
  boxHeight: 120,

  isMobile: false,
})

createApp({
  components: {
    companyProfileBar,
    companyProfileContact,
    companyProfileFaq,
    companyProfileGallery,
    companyProfileHeader,
    companyProfileInfo,
    companyProfileLocation,
    companyProfileRating,
    companyProfileReview,
    companyProfileSkill,
    collapseContent,
  },

  data() {
    return initialState()
  },

  mounted() {
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches

    this.boxHeight = this.isMobile
      ? 120
      : 250
  },

  computed: {
    ...mapState({
      info: state => state.companyProfile.info,
    })
  },
})